import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import {actionBuryPointWay} from './plugins/actionBuryPoint.js' // 仿友盟 日志记录
import "tailwindcss/tailwind.css"

import router from './router'
// import "./theme/index.css";
import store from './store'
import {jsonPost, post, get, uploadPost} from './utils/http'
import axiosUrl from './utils/axiosUrl'
import NProgress from 'nprogress' // 引入nprogress插件
import 'nprogress/nprogress.css'  // 这个nprogress样式必须引入
import preventReClick from './utils/preventReClick'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

Vue.config.productionTip = false
// 定义全局变量
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$jsonPost = jsonPost
Vue.prototype.$uploadPost = uploadPost
Vue.prototype.$axiosUrl = axiosUrl
Vue.prototype.$actionBuryPointWay = actionBuryPointWay
Vue.use(preventReClick)
// 事件总线
Vue.prototype.$bus = new Vue()
router.beforeEach((to, from, next) => {
  // start progress bar
  NProgress.start()
  next()
  NProgress.done()
})
// router.afterEach((to) => PVBuryPointWay(to))

Vue.directive('highlight',function (el) {
  let blocks = el.querySelectorAll('pre code');
  blocks.forEach((block)=>{
    // eslint-disable-next-line no-undef
    hljs.highlightBlock(block)
  })
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
